import {
  setIsLoggedIn,
  setRefAddress,
  setToken,
  setUserInfo,
} from "../Redux/WallatSlice";

export function logout(dispatch) {
  dispatch(setIsLoggedIn(false));
  dispatch(setToken(""));
  dispatch(setUserInfo({}));
  dispatch(setRefAddress(""));
}

export function getDaysOld(timestamp, maxdays, set, timerRef) {
  clearInterval(timerRef.current); // Stop the previous timer

  timerRef.current = setInterval(() => {
    const currentTimestamp = Math.floor(new Date().getTime() / 1000); // Current time in seconds
    const endTimestamp = timestamp + maxdays * 24 * 60 * 60; // End timestamp in seconds

    let timeDifference = endTimestamp - currentTimestamp; // Difference in seconds

    if (timeDifference <= 0) {
      clearInterval(timerRef.current); // Stop the timer
      timerRef.current = null; // Clear the reference
      set("00D : 00H : 00M : 00S");
      return; // Exit the function
    }

    const days = Math.floor(timeDifference / (24 * 60 * 60)); // Calculate days
    timeDifference %= 24 * 60 * 60; // Remaining seconds after days

    const hours = Math.floor(timeDifference / (60 * 60)); // Calculate hours
    timeDifference %= 60 * 60; // Remaining seconds after hours

    const minutes = Math.floor(timeDifference / 60); // Calculate minutes
    const seconds = timeDifference % 60; // Remaining seconds

    set(`${days}D : ${hours}H : ${minutes}M : ${seconds}S`);
  }, 1000); // Update every second
}